<template>
  <div class="menuWrapper">
    <LoadingOverlay :isVisible="isLoading" />
    <div class="menu">
      <div v-if="menuStep != countSteps" class="menuHead">
        <a href="/">
          <img class="logo" src="../assets/img/logo.png" />
        </a>
      </div>

      <div v-if="(!isMobile && menuStep != countSteps) || menuStep == 1">
        <Recorder
          :p5container="p5container"
          @audioAvailable="onAudioAvailable"
        />
        <FileUpload
          @audioAvailable="onAudioAvailable"
          @fileProcessingStateChanged="onFileProcessingStateChanged"
          :p5container="p5container"
        />
        <AudioPlayer :audioUrl="audioUrl" />
        <PlaybackInput :playback-options="posterState.playbackOptions" />
      </div>

      <LayoutInput
        v-if="(!isMobile && menuStep != countSteps) || menuStep == 2"
        v-model="posterState.layout"
      />

      <ColorInput
        v-if="
          ((!isMobile && menuStep != countSteps) || menuStep == 2) &&
            posterState.colorClassic
        "
        v-model="posterState.colorClassic"
      />

      <DedicationInput
        v-if="(!isMobile && menuStep != countSteps) || menuStep == 3"
        :poster-state="posterState"
      />

      <OptionsInput
        v-if="(!isMobile && menuStep != countSteps) || menuStep == 4"
        :poster-options="posterState.options"
      />

      <ConfirmationInput
        :delivery-times="deliveryTimes"
        v-if="menuStep == 5"
      ></ConfirmationInput>
    </div>

    <div class="buttonWrapper">
      <button id="buttonPrev" class="btnMenuSecondary" @click="prev()">
        Zurück
      </button>
      <button
        v-if="menuStep != countSteps"
        id="buttonNext"
        class="btnMenuPrimary"
        @click="next()"
        :disabled="isNextButtonDisabled"
      >
        Weiter
      </button>
    </div>
    <span style="font-size:0px" class="header-calligraphy"
      >This is a workaround to load the calligraphy font asap</span
    >
  </div>
</template>

<script>
import DedicationInput from './menu/DedicationInput'
import ConfirmationInput from './menu/ConfirmationInput'
import LayoutInput from './menu/LayoutInput'
import Recorder from './menu/Recorder'
import OptionsInput from './menu/OptionsInput'
import ColorInput from './menu/ColorInput'
import PlaybackInput from './menu/PlaybackInput'
import FileUpload from './menu/FileUpload'
import AudioPlayer from './menu/AudioPlayer'
import LoadingOverlay from './menu/LoadingOverlay'
import getDeliveryTimes from '../provider/deliveryTimeProvider'
import { store } from '../store/store'

export default {
  name: 'Menu',
  props: {
    posterState: Object,
    p5container: Object,
    isMobile: Boolean,
  },
  data() {
    return {
      // 0 means the mobile menu is disabled
      menuStep: 1,
      countSteps: 5,
      deliveryTimes: null,
      soundFile: null,
      audioUrl: null,
      isLoading: false,
      isAudioProvided: false, // If a imnitial PosterId is set (edit Poster), we assume there is already an audio
      // This property is used to hide the PinterestMessage if the window has been resized.
      // It is needed since on Daniels Phone the page is not being reloaded when openend in Chrome
      // But the only detectable change is a resize
      wasResized: false,
    }
  },
  created() {
    window.addEventListener('resize', this.handleWindowResizeEvent)
  },
  mounted() {
    getDeliveryTimes().then((data) => {
      this.deliveryTimes = data
    })
  },
  computed: {
    isLastNextButton() {
      return this.isMobile ? this.menuStep === this.countSteps - 1 : true
    },
    // TODO instead of disabled show hint about Recording missing
    isNextButtonDisabled() {
      if (!this.isLastNextButton) {
        return false
      } else if (store.state.error) {
        return true
      } else {
        return !this.isAudioProvided && !store.getters.isValidEditState
      }
    },
  },
  methods: {
    async onAudioAvailable(soundFile) {
      this.$emit('audioAvailable', soundFile.p5soundFile)
      this.isAudioProvided = true
      this.audioUrl = soundFile.audioUrl
      this.posterState.isRecording = soundFile.isRecording
    },

    onFileProcessingStateChanged(state) {
      this.isLoading = state.isProcessing
    },
    handleWindowResizeEvent() {
      this.wasResized = true
    },
    prev() {
      if (this.menuStep == 1) {
        window.open('https://myvoiceposter.de', '_self')
      } else {
        if (this.isMobile) {
          this.menuStep--
          window.scrollTo({ top: 0, left: 0 })
        } else {
          this.menuStep = 1
        }
      }
      this.$emit('menuStepChanged', this.menuStep)
    },
    next() {
      if (this.isMobile) {
        this.menuStep++
        window.scrollTo({ top: 0, left: 0 })
      } else {
        this.menuStep = this.countSteps
      }
      if (this.menuStep == this.countSteps) {
        store.dispatch('savePoster')
      }
      this.$emit('menuStepChanged', this.menuStep)
    },
  },
  components: {
    DedicationInput,
    ConfirmationInput,
    LayoutInput,
    OptionsInput,
    Recorder,
    ColorInput,
    PlaybackInput,
    FileUpload,
    AudioPlayer,
    LoadingOverlay,
  },
}
</script>
